import {useState} from 'react'
import settings from '../machineSettingsData'

function usePhases() {
    const [winningPhase] = useState(settings.winningPhase)
    const [phase, setPhase] = useState(0)
    
    function updatePhase(action='increase') {
        switch(action) {
            case 'increase': {
                return setPhase(prevPhase => {
                    return (
                        prevPhase < winningPhase ? 
                            prevPhase + 1 : prevPhase
                    )
                })
            }
            
            case 'decrease': {
                return setPhase(prevPhase => {
                    return (
                        prevPhase > 0 ? prevPhase - 1 : prevPhase
                    )
                })
            }
                
            case 'reset': {
                return setPhase(0)
            }
                
            default:
                return phase
        }
        
    }
    
    return {phase, winningPhase, updatePhase}
}

export default usePhases